<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>



      <v-col cols="12">
        <v-card class="my-0">
          <v-card-title>
            Principal
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">

                <punto-venta-combobox
                    v-model.number="form.PtoVta"
                    :input-errors="inputErrors"

                />

              </v-col>


              <v-col cols="12" sm="4">

                <tipo-comprobante-combobox
                    v-model.number="form.CbteTipo"
                    :input-errors="inputErrors"
                    @input="OnChangeTipoComprobante"
                />

              </v-col>


              <v-col cols="12" sm="4">

                <tipo-concepto-combobox
                    v-model="form.Concepto"
                    :input-errors="inputErrors"
                />

              </v-col>

              <v-col cols="12" sm="4">
                <date-input
                    v-model="form.CbteFch"
                    :label="$t('afip.factura.labels.CbteFch')"
                    :error="hasInputErrors('CbteFch')"
                    :error-messages="getInputErrors('CbteFch')"
                />
              </v-col>


              <v-col cols="12" sm="6">
                <v-text-field

                    prepend-icon="description"
                    name="ProductoServicio"
                    v-model="form.ProductoServicio"
                    :label="$t('afip.factura.labels.ProductoServicio')"
                    :placeholder="$t('afip.factura.labels.ProductoServicio')"
                    :error="hasInputErrors('ProductoServicio')"
                    :error-messages="getInputErrors('ProductoServicio')"
                    color="secondary"

                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="isServicio">
        <v-card class="my-0">
          <v-card-title>
            Fechas de Servicio
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <date-input
                    v-model="form.FchServDesde"
                    :label="$t('afip.factura.labels.FchServDesde')"
                    :error="hasInputErrors('FchServDesde')"
                    :error-messages="getInputErrors('FchServDesde')"
                    :rules="required"
                />
              </v-col>


              <v-col cols="12" sm="4">
                <date-input
                    v-model="form.FchServHasta"
                    :label="$t('afip.factura.labels.FchServHasta')"
                    :error="hasInputErrors('FchServHasta')"
                    :error-messages="getInputErrors('FchServHasta')"
                    :rules="required"
                />
              </v-col>


              <v-col cols="12" sm="4">
                <date-input
                    v-model="form.FchVtoPago"
                    :label="$t('afip.factura.labels.FchVtoPago')"
                    :error="hasInputErrors('FchVtoPago')"
                    :error-messages="getInputErrors('FchVtoPago')"
                    :rules="required"
                />
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="my-0">
          <v-card-title>
            Receptor
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <tipo-documento-combobox
                    v-model="form.DocTipo"
                    :input-errors="inputErrors"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-text-field

                    prepend-icon="description"
                    name="DocNro"
                    v-model.number="form.DocNro"
                    type="number"
                    :label="$t('afip.factura.labels.DocNro')"
                    :placeholder="$t('afip.factura.labels.DocNro')"
                    :error="hasInputErrors('DocNro')"
                    :error-messages="getInputErrors('DocNro')"
                    color="secondary"

                ></v-text-field>
              </v-col>


              <v-col cols="12" sm="4">
                <v-text-field

                    prepend-icon="person"
                    name="RazonSocialReceptor"
                    v-model="form.RazonSocialReceptor"
                    :label="$t('afip.factura.labels.RazonSocialReceptor')"
                    :placeholder="$t('afip.factura.labels.RazonSocialReceptor')"
                    :error="hasInputErrors('RazonSocialReceptor')"
                    :error-messages="getInputErrors('RazonSocialReceptor')"
                    color="secondary"

                ></v-text-field>
              </v-col>


              <v-col cols="12" sm="4">
                <v-text-field

                    prepend-icon="place"
                    name="DomicilioReceptor"
                    v-model="form.DomicilioReceptor"
                    :label="$t('afip.factura.labels.DomicilioReceptor')"
                    :placeholder="$t('afip.factura.labels.DomicilioReceptor')"
                    :error="hasInputErrors('DomicilioReceptor')"
                    :error-messages="getInputErrors('DomicilioReceptor')"
                    color="secondary"

                ></v-text-field>
              </v-col>



              <v-col cols="12" sm="4">

                <condicion-iva-combobox
                    v-model="form.CondicionIVAReceptor"
                    :input-errors="inputErrors"
                ></condicion-iva-combobox>

              </v-col>

              <v-col cols="12" sm="4">

                <condicion-venta-combobox
                    v-model="form.CondicionVenta"
                    :input-errors="inputErrors"
                ></condicion-venta-combobox>

              </v-col>


            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="my-0">
          <v-card-title>
            Moneda
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <tipo-moneda-combobox  v-model="form.MonId"></tipo-moneda-combobox>
              </v-col>


              <v-col cols="12" sm="4">
                <v-text-field

                    prepend-icon="money"
                    name="MonCotiz"
                    v-model.number="form.MonCotiz"
                    type="number"
                    :label="$t('afip.factura.labels.MonCotiz')"
                    :placeholder="$t('afip.factura.labels.MonCotiz')"
                    :error="hasInputErrors('MonCotiz')"
                    :error-messages="getInputErrors('MonCotiz')"
                    color="secondary"

                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>


      <v-col cols="12">
        <v-card class="my-0">
          <v-card-title>
            Detalle de productos y servicios
          </v-card-title>

          <v-card-text>
            <form-list
                :min-length="1"
                :new-item="{
                            codigo: '',
                            ProductoServicio: '',
                            cantidad: 1,
                            unidadMedida:  'Unidades',
                            precioUnitario:  null,
                            precioUnitarioConIva:  null,
                            bonificacion:  null,
                            subtotal:  null,
                            alicuotaIva: null,
                            subtotalConIva:  null,
                          }"
                :value="form.detalleProductoServicio"
            >

              <template v-slot:default="{ item, index}">
                  <factura-form-detalle-producto-servicio
                      v-model="form.detalleProductoServicio[index]"
                      :iva="[1,6].includes(form.CbteTipo)"
                  ></factura-form-detalle-producto-servicio>
              </template>


            </form-list>
          </v-card-text>

        </v-card>
      </v-col>


      <v-col cols="12" sm="12" md="12">
        <totales-factura :receipt="receiptTotal(form.CbteTipo, form.detalleProductoServicio)"></totales-factura>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule, FormList} from '@dracul/common-frontend'
import PuntoVentaCombobox from "@/modules/afip/components/PuntoVentaCombobox/PuntoVentaCombobox";
import TipoComprobanteCombobox from "@/modules/afip/components/TipoComprobanteCombobox/TipoComprobanteCombobox";
import TipoConceptoCombobox from "@/modules/afip/components/TipoConceptoCombobox/TipoConceptoCombobox";
import TipoDocumentoCombobox from "@/modules/afip/components/TipoDocumentoCombobox/TipoDocumentoCombobox";
import CondicionVentaCombobox from "@/modules/afip/components/CondicionVentaCombobox/CondicionVentaCombobox";
import {DayjsMixin, DateInput} from "@dracul/dayjs-frontend";
import CondicionIvaCombobox from "@/modules/afip/components/CondicionIvaCombobox/CondicionIvaCombobox";
import FacturaFormDetalleProductoServicio
  from "@/modules/afip/pages/crud/FacturaPage/FacturaForm/FacturaFormDetalleProductoServicio";
import TipoMonedaCombobox from "@/modules/afip/components/TipoMonedaCombobox/TipoMonedaCombobox";
import AfipMixin from "@/modules/afip/mixins/AfipMixin";
import CurrencyMixin from "@/modules/afip/mixins/CurrencyMixin";
import TotalesFactura from "@/modules/afip/components/TotalesFactura/TotalesFactura";
import IvaMixin from "@/modules/afip/mixins/IvaMixin";
import ReceiptTotalMixin from "@/modules/afip/mixins/ReceiptTotalMixin";

export default {
  name: "FacturaForm",
  components: {
    TotalesFactura,
    TipoMonedaCombobox,
    FacturaFormDetalleProductoServicio,
    CondicionIvaCombobox,
    DateInput,
    CondicionVentaCombobox,
    TipoDocumentoCombobox,
    TipoConceptoCombobox,
    TipoComprobanteCombobox,
    PuntoVentaCombobox,
    FormList
  },
  mixins: [InputErrorsByProps, RequiredRule, DayjsMixin, AfipMixin, CurrencyMixin, IvaMixin, ReceiptTotalMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    ivaRequired() {
      return (this.form.CbteTipo == 6 || this.form.CbteTipo == 1)
    },
    isServicio() {
      return (this.form.Concepto == 2 || this.form.Concepto == 3)
    },
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },


  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    round(number) {
      return Math.round((number + Number.EPSILON) * 100) / 100
    },
    validate() {
      return this.$refs.form.validate()
    },
    OnChangeTipoComprobante(val) {
      switch (val) {
        case 6:
          this.form.CondicionIVAReceptor = 'Consumidor Final'
          this.form.DocTipo = 99
          break
        case 1:
          this.form.CondicionIVAReceptor = 'Responsable Inscripto'
          this.form.DocTipo = 80
          break
        default:
          this.form.CondicionIVAReceptor = ''
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

